import { useState, useEffect, useRef } from "react";
import backgroundimg from "../Images/banner-bg.jpg";
import emailjs from "emailjs-com";
import { countriesList } from "../utility/constants";
import { useMediaQuery } from "@material-ui/core";
import { Helmet } from "react-helmet";
import { medicals } from "./config";
import NukaCarousel from "../tools/NukaCarousel";
import { faqs } from "./config";
import { faqsss } from "./config";
import docgirl from "../Images/home/medicbot.png";
import CenteredAlert from "./CenteredAlert";
import ServiceCall from "../ServiceCall";
import { ArrowRight, CheckCircle, Phone, Mail, Clock , MapPin, User, Send, FileText, Heart , MessageSquare, Users, DollarSign, Headphones , Plus, Minus , Truck , Shield} from 'lucide-react';
import {
  TextField,
  Button,
  Container,
  makeStyles,
  FormControl,
  InputLabel,
  InputAdornment,
  Input,
  MenuItem,
  FormHelperText,
  Select,
  Grid,
} from "@material-ui/core";
import HospitalTreatmentsShowcase from "./HospitalTreatmentsShowcase";
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: theme.spacing(4),
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
    "& .MuiFormControl-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(2, 0),
    backgroundColor: "#199a8e",
    "&:hover": {
      // Remove hover effect
      backgroundColor: "#199a8e",
    },
  },
  salutationFormControl: {
    width: "27%", // Adjust the width of the salutation select
  },
  gender: {
    width: "30%",
  },
  nameContainer: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
  },
  nameField: {
    background: "white",
  },
  select: {
    border: "none", // Remove border
    width: "50px", // Adjust the width as needed
  },
}));

const Medine = () => {
  const classes = useStyles();
  const [loader, setLoader] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [phoneCode, setPhoneCode] = useState("+91");
  const [message, setMessage] = useState("");
  const [name, setName] = useState("");
  const [pin, setPin] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [gender, setGender] = useState("");
  const [country, setCountry] = useState("");
  const [city, setCity] = useState("");
  const isMobile = useMediaQuery("(max-width:710px)");
  const isValidPhoneNumber = (phoneNumber) => {
    const numericPhoneNumber = phoneNumber.replace(/\D/g, "");
    return numericPhoneNumber.length === 10 && /^\d+$/.test(numericPhoneNumber);
  };
  const [expandedQuestions, setExpandedQuestions] = useState([]);
const [loading, setLoading] = useState(false);
const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: ''
  });
   const [submitted, setSubmitted] = useState(false);
   const handleContactNowClick = () => {
  const section = document.getElementById("consultation");
  if (section) {
    section.scrollIntoView({ behavior: "smooth" });
  }
};
  const [showAlert, setShowAlert] = useState(false);
   const formRef = useRef(null);
   const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };
  const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  const mode = process.env.REACT_APP_MODE; // e.g., 'dev', 'prod'

  const payload = {
    email: formData.email,
    country_code: '+91', // 🔧 Replace with dynamic code if available
    phone: formData.phone,
    name: formData.name,
    address: formData.address,
    source_url: 'https://rxone.app/order-medicine-online-india',
    request_type: 'medicine',
    coupon_code: '' // 🔧 Optional: add value if needed
  };

  try {
    await ServiceCall.post(`/rxopd/rxone/patient/treatment/advice/contactus/form/${mode}`, payload);

    setSubmitted(true);
    setTimeout(() => {
      setFormData({ name: '', email: '', phone: '', address: '' });
      setSubmitted(false);
    }, 3000);
  } catch (error) {
    console.error('API submission error:', error);
    alert('Failed to submit the form. Please try again.');
  } finally {
    setLoading(false);
  }
};

  const toggleQuestion = (id) => {
    if (expandedQuestions.includes(id)) {
      setExpandedQuestions(expandedQuestions.filter((qid) => qid !== id));
    } else {
      setExpandedQuestions([...expandedQuestions, id]);
    }
  };
const [expandedId, setExpandedId] = useState(null);

  const toggle = (id) => {
    setExpandedId((prev) => (prev === id ? null : id));
  };
  const titlle =
    "FREE Treatment Advice - Consult for Medine Treatment Advice - Allopathy, Homeopathy, Ayurveda, Unani, Sowa-Rigpa, Siddha, Yoga, Reki, Naturopathy, Meditation, Physiotherapy, Mental Health | RxOne";
  const desc =
    "Get free treatment advice and consult for medical treatments including Allopathy, Homeopathy, Ayurveda, Unani, Sowa-Rigpa, Siddha, Yoga, Reki, Naturopathy, Meditation, Physiotherapy, and Mental Health at RxOne.";
  return (
    <>
      <Helmet>{<title>{titlle}</title>}</Helmet>
      <Helmet>{<meta name="description" content={desc} />}</Helmet>

     <div className="bg-gradient-to-br from-teal-100 via-white to-blue-50 min-h-screen">
    <section id="consultation" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 mt-20 ">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div>
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
                Get Up To <span className="text-teal-600">30% Discount </span> on Medicine 
              </h1>
              <p className="mt-6 text-xl text-gray-600 leading-relaxed">
               Order your medicines online and get the best prices with fast doorstep delivery. Quality medicines from certified pharmacies with guaranteed authenticity.
              </p>
            </div>
            
            <div className="flex flex-wrap gap-4">
              <a href="#services" className="inline-flex items-center px-6 py-3 bg-teal-600 text-white font-medium rounded-lg shadow-md hover:bg-teal-700 transition-colors">
                Contact Us
                <ArrowRight className="ml-2 h-5 w-5" />
              </a>
       {/* <a
  href="#contact"
  className="inline-flex items-center px-6 py-3 bg-white text-teal-600 border border-teal-600 font-medium rounded-lg transition-colors hover:bg-teal-50 hover:text-teal-700 hover:border-teal-700"
>
  Contact Us
</a> */}

            </div>
            
            <div className="space-y-4 pt-2">
              <div className="flex items-center gap-3">
                <div className="bg-teal-100 p-2 rounded-full text-teal-600">
                  <Phone className="h-6 w-6" />
                </div>
                <span className="text-gray-700 font-medium">We'll contact you within 24 hours</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="bg-teal-100 p-2 rounded-full text-teal-600">
                  <Clock className="h-6 w-6" />
                </div>
                <span className="text-gray-700 font-medium">Up to 30% discount guaranteed</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="bg-teal-100 p-2 rounded-full text-teal-600">
                  <Truck className="h-6 w-6" />
                </div>
                <span className="text-gray-700 font-medium">Fast doorstep delivery</span>
              </div>
            </div>
          </div>
          
          <div>
         
 

   <div className="lg:pl-12" ref={formRef}>
  <div className="bg-white rounded-2xl shadow-2xl p-6 lg:p-8 relative overflow-hidden">
    {/* Decorative Elements */}
    <div className="absolute top-0 right-0 w-32 h-32 opacity-10 transform rotate-12">
      <div className="w-full h-full rounded-full" style={{ backgroundColor: 'rgb(1, 154, 158)' }}></div>
    </div>
    <div className="absolute bottom-0 left-0 w-24 h-24 opacity-5 transform -rotate-12">
      <div className="w-full h-full rounded-full" style={{ backgroundColor: 'rgb(1, 154, 158)' }}></div>
    </div>

    {submitted ? (
      <div className="text-center py-4">
        <div className="w-16 h-16 mx-auto mb-3 rounded-full flex items-center justify-center" style={{ backgroundColor: 'rgba(1, 154, 158, 0.1)' }}>
          <CheckCircle className="w-8 h-8" style={{ color: 'rgb(1, 154, 158)' }} />
        </div>
        <h3 className="text-2xl font-bold text-gray-900 mb-1">Thank You!</h3>
        <p className="text-sm text-gray-600">Your message has been sent successfully. We'll get back to you soon.</p>
      </div>
    ) : (
      <>
       <div className="text-center mb-4">
  <h2 className="text-4xl font-extrabold text-gray-900 mb-3 flex items-center justify-center gap-3">
  <span
    style={{
      letterSpacing: "1px",
      // textTransform: "uppercase",
      background: "linear-gradient(90deg, #019a9e 0%, #00c6b7 100%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      display: "inline-block"
    }}
  >
    Contact Now 
  </span>
  {/* <img
    src={phantompic}
    alt="PanTum Logo"
    style={{
      display: "inline-block",
      verticalAlign: "middle",
      height: "30px",
      marginBottom: "2px"
    }}
  /> */}
</h2>
  <p className="text-sm text-gray-600">
    Fill out the form and we'll contact you within 24 hours
  </p>
</div>

        <div className="space-y-4">
          {/* Name Field */}
          <div>
            <label className="flex items-center text-sm font-semibold text-gray-700 mb-1">
              <User className="w-4 h-4 mr-2 text-gray-500" />
              Full Name *
            </label>
            <input
              type="text"
              name="name"
              placeholder="Enter your full name"
              value={formData.name}
              onChange={handleChange}
              required
              className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent transition-all duration-200 bg-gray-50 hover:bg-white"
              style={{ '--tw-ring-color': 'rgb(1, 154, 158)' }}
            />
          </div>

          {/* Email Field */}
          <div>
            <label className="flex items-center text-sm font-semibold text-gray-700 mb-1">
              <Mail className="w-4 h-4 mr-2 text-gray-500" />
              Email Address *
            </label>
            <input
              type="email"
              name="email"
              placeholder="Enter your email address"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent transition-all duration-200 bg-gray-50 hover:bg-white"
              style={{ '--tw-ring-color': 'rgb(1, 154, 158)' }}
            />
          </div>

          {/* Phone Field */}
          <div>
            <label className="flex items-center text-sm font-semibold text-gray-700 mb-1">
              <Phone className="w-4 h-4 mr-2 text-gray-500" />
              Phone Number *
            </label>
            <input
              type="tel"
              name="phone"
              placeholder="Enter your phone number"
              value={formData.phone}
              onChange={handleChange}
              required
              className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent transition-all duration-200 bg-gray-50 hover:bg-white"
              style={{ '--tw-ring-color': 'rgb(1, 154, 158)' }}
            />
          </div>

          {/* Address Field */}
          <div>
            <label className="flex items-center text-sm font-semibold text-gray-700 mb-1">
              <MapPin className="w-4 h-4 mr-2 text-gray-500" />
              Address *
            </label>
            <textarea
              name="address"
              placeholder="Enter your complete address"
              rows="2"
              value={formData.address}
              onChange={handleChange}
              required
              className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent transition-all duration-200 bg-gray-50 hover:bg-white resize-none"
              style={{ '--tw-ring-color': 'rgb(1, 154, 158)' }}
            />
          </div>

          {/* Submit Button */}
          <button
            type="button"
            onClick={handleSubmit}
            disabled={loading}
            className={`w-full flex items-center justify-center px-6 py-3 rounded-lg font-semibold text-white transition-all duration-200 transform hover:scale-105 hover:shadow-lg ${
              loading ? 'opacity-70 cursor-not-allowed' : 'hover:shadow-xl'
            }`}
            style={{
              backgroundColor: loading ? '#gray' : 'rgb(1, 154, 158)',
              boxShadow: loading ? 'none' : '0 4px 15px rgba(1, 154, 158, 0.3)',
            }}
          >
            {loading ? (
              <>
                <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                Submitting...
              </>
            ) : (
              <>
                <Send className="w-5 h-5 mr-2" />
                Submit
              </>
            )}
          </button>

          {/* Trust Indicators */}
          {/* <div className="pt-3 border-t border-gray-100">
            <div className="flex items-center justify-center space-x-4 text-xs text-gray-500">
              <div className="flex items-center">
                <Shield className="w-4 h-4 mr-1" style={{ color: 'rgb(1, 154, 158)' }} />
                SSL Secured
              </div>
              <div className="flex items-center">
                <CheckCircle className="w-4 h-4 mr-1" style={{ color: 'rgb(1, 154, 158)' }} />
                No Spam
              </div>
              <div className="flex items-center">
                <Star className="w-4 h-4 mr-1" style={{ color: 'rgb(1, 154, 158)' }} />
                Trusted
              </div>
            </div>
          </div> */}
        </div>
      </>
    )}
  </div>
</div>


          </div>
        </div>
      </section>

      </div>
      {showAlert && (
        <CenteredAlert
          message="We have received your request, please allow us up-to 24 Hrs. to come back to you."
          onClose={() => setShowAlert(false)}
        />
      )}
       <section className="py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            How It Works
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
           Simple steps to get your medicines delivered to your doorstep with guaranteed savings.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
          {/* Step 1 */}
          <div className="text-center relative">
            <div className="w-20 h-20 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-6 relative">
              <FileText className="w-10 h-10 text-white" />
              <div className="absolute -top-2 -right-2 w-8 h-8 bg-cyan-500 rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-sm">1</span>
              </div>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-4">
              Fill the form & we contact you within 24 hr
            </h3>
            <p className="text-gray-600 leading-relaxed">
             Simply fill out our order form with your prescription details and contact information. Our team will reach out to you within 24 hours to confirm your order.
            </p>
            <div className="hidden md:block absolute top-10 left-full w-full h-0.5 bg-gray-200 transform -translate-y-1/2 z-0">
              <div className="absolute right-0 top-1/2 transform -translate-y-1/2 w-3 h-3 bg-teal-600 rounded-full"></div>
            </div>
          </div>

          {/* Step 2 */}
          <div className="text-center relative">
            <div className="w-20 h-20 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-6 relative">
              <Phone className="w-10 h-10 text-white" />
              <div className="absolute -top-2 -right-2 w-8 h-8 bg-cyan-500 rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-sm">2</span>
              </div>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-4">
              RxOne expert will call you and confirm delivery
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Our pharmaceutical expert will call you to verify your prescription, confirm the medicines, and arrange the most convenient delivery time for you.
            </p>
            <div className="hidden md:block absolute top-10 left-full w-full h-0.5 bg-gray-200 transform -translate-y-1/2 z-0">
              <div className="absolute right-0 top-1/2 transform -translate-y-1/2 w-3 h-3 bg-teal-600 rounded-full"></div>
            </div>
          </div>

          {/* Step 3 */}
          <div className="text-center">
            <div className="w-20 h-20 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-6 relative">
              <Truck className="w-10 h-10 text-white" />
              <div className="absolute -top-2 -right-2 w-8 h-8 bg-cyan-500 rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-sm">3</span>
              </div>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-4">
             Your medicines will be delivered at doorstep
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Your authentic medicines will be safely delivered to your doorstep by our trusted delivery partners, ensuring you get quality healthcare at home.
            </p>
          </div>
        </div>

        {/* Custom CTA Button */}
        <div className="text-center mt-12">
        <button
  className="px-6 py-3 text-lg font-semibold text-white bg-teal-600 hover:bg-teal-700 rounded-lg transition duration-300"
  onClick={handleContactNowClick}
>
  Contact Now
</button>
        </div>
      </div>
    </section>

       <section className="py-16 bg-white">
      <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            Terms and Conditions
          </h2>
          <p className="text-xl text-gray-600">
            Important information about our medicine delivery service
          </p>
        </div>

        <div className="bg-gray-50 rounded-lg p-8 space-y-6">
          <div className="text-gray-700 text-base leading-relaxed space-y-4">
            <p>
              The Pharmaceutical Drugs and Services shall be delivered by the Third Party Pharmacy or independent contractors.
              You accept and acknowledge that the Third Party Pharmacy or such other transporter/courier/delivery personnel,
              engaged by the Third Party Pharmacy or RxOne, shall be independent contractors in charge of the delivery of the
              Pharmaceutical Drugs and Services from the concerned Third Party Pharmacy to the address notified by you,
              with no control over the Pharmaceutical Drugs and Services and no additional obligation apart from standard
              delivery obligations and duty of care.
            </p>

            <p>
              You further accept and acknowledge that RxOne does not engage in the distribution of the Pharmaceutical Drugs
              and Services, and may provide the services of a third party transporter/courier delivery personnel for the
              purposes of delivery of Pharmaceutical Drugs and Services from the concerned Third Party Pharmacy to the
              address notified by you.
            </p>
           <p>
  <strong>*FREE Delivery on Medicine orders of Rs. 1000 or more.</strong>
</p>
          </div>

          <div className="border-t border-gray-200 pt-6">
            <div className="flex items-center space-x-3">
              <Shield className="w-6 h-6 text-teal-600" />
              <span className="text-sm text-gray-600 font-medium">
                By placing an order, you agree to these terms and conditions
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
     <HospitalTreatmentsShowcase />
  <section className="py-16 bg-teal-600">
      <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6">
           Ready to Save on Your Medicines?
        </h2>
        <p className="text-xl text-white/90 mb-8">
          Join thousands of customers who trust RxOne for their medicine needs. 
            Get up to 30% discount on your first order.
        </p>
        <button className="px-6 py-3 bg-white text-teal-600 text-lg font-semibold rounded-lg hover:bg-gray-100 transition duration-300" onClick={handleContactNowClick} >
           Order Medicines Now
        </button>
      </div>
    </section>
      <section className="py-20 bg-gray-50">
<div className="w-full px-4 sm:px-6 lg:px-8">
    <h2 className="text-3xl lg:text-4xl font-bold text-gray-800 mb-10 text-center">
      Frequently Asked Questions
    </h2>

    <div className="space-y-5">
     {faqsss.map((faq) => (
        <div
          key={faq.id}
          className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden transition-all duration-300"
        >
          <button
            onClick={() => toggle(faq.id)}
            className="flex justify-between items-center w-full px-4 py-4 text-left text-gray-800 font-medium hover:bg-gray-100 focus:outline-none"
          >
            <span className="text-sm sm:text-base">{faq.question}</span>
            <span className="ml-4 text-teal-600">
              {expandedId === faq.id ? <Minus size={18} /> : <Plus size={18} />}
            </span>
          </button>

          <div
            className={`px-4 pt-0 pb-4 text-gray-600 text-sm transition-all duration-300 ${
              expandedId === faq.id ? 'block' : 'hidden'
            }`}
          >
            {faq.answer}
          </div>
        </div>
      ))}
    </div>
  </div>
</section>
    </>
  );
};
export default Medine;
